import Loadable from '@townsquare/loadable';

export const StatusUpdatesView = Loadable({
	loader: () => import(/* webpackChunkName: "StatusUpdatesView" */ './StatusUpdates'),
	loading: () => null,
});
